import DomFactory from "../Utils/DomFactory";
import ProductState from "./ProductState";
import Events from "../Utils/Events";
import * as Util from "../Utils/Util";
import Hider from "../Utils/Hider";

export default class PriceViewer {
  private readonly priceWrapperElement: HTMLElement;
  private readonly priceElement: HTMLElement;
  private readonly salePriceWrapperElement: HTMLElement | undefined;
  private readonly salePriceElement: HTMLElement | undefined;
  private readonly pricePerElement: HTMLElement;
  private readonly pricePerUnitElement: HTMLElement;

  private readonly subscriptionSavingLabelElement: HTMLElement | undefined;
  private readonly subscriptionSavingLabelAmountElement: HTMLElement | undefined;
  private readonly subscriptionPerItemNote: HTMLElement | undefined;
  private readonly containerElement: HTMLElement;

  public constructor(element: HTMLElement) {
    this.containerElement = element;
    this.priceWrapperElement = Util.findByBindName("price-viewer-price-holder", element) as HTMLElement;
    this.priceElement = Util.findByBindName("price-viewer-price", element) as HTMLElement;
    this.salePriceWrapperElement = Util.findByBindName("price-viewer-sale-price-holder", element) as
      | HTMLElement
      | undefined;
    this.salePriceElement = Util.findByBindName("price-viewer-discounted-price", element) as HTMLElement | undefined;
    this.pricePerElement = Util.findByBindName("price-viewer-price-per", element) as HTMLElement;
    this.pricePerUnitElement = Util.findByBindName("price-viewer-price-per-unit", element) as HTMLElement;
    this.subscriptionSavingLabelElement = Util.findByBindName("subscription-saving-label", element) as
      | HTMLElement
      | undefined;
    this.subscriptionSavingLabelAmountElement = Util.findByBindName("subscription-saving-label-amount", element) as
      | HTMLElement
      | undefined;
    this.subscriptionPerItemNote = Util.findByBindName("subscription-per-item-note", element) as
      | HTMLElement
      | undefined;

    //this.subscriptionPerItemNote = Util.findByBindName("subscription-per-item-note", element) as HTMLElement;
    Events.on("init-with-prices", this.refreshPrices.bind(this));
  }

  private refreshPrices() {
    Events.on("product-state-change", (s: ProductState) => this.updatePrices(s));
    Events.fire("product-state-change-request", this);
  }

  private updatePrices(state: ProductState) {
    const discount = state.quantity.discount;
    const price = state.quantity.price;

    const discountedPrice = discount != null ? discount.priceAfterDiscount : price;

    this.containerElement.classList.remove("hidden");
    this.priceElement.innerHTML = price.toFixed(2);

    const pricePer: string = (discountedPrice / parseInt(state.quantity.code)).toFixed(2);
    const pricePerUnit: string = state.quantity.unit;

    if (this.salePriceElement) {
      this.salePriceElement.innerHTML = discountedPrice.toFixed(2);
    }

    if (this.pricePerElement) {
      this.pricePerElement.innerHTML = pricePer;
    }

    if (this.pricePerUnitElement) {
      this.pricePerUnitElement.innerHTML = pricePerUnit;
    }

    if (this.salePriceWrapperElement && discount != null) {
      Hider.show(this.salePriceWrapperElement);
      this.priceWrapperElement.classList.remove("price");
      this.priceWrapperElement.classList.add("price-original");
    } else if (this.salePriceWrapperElement) {
      Hider.hide(this.salePriceWrapperElement);
      this.priceWrapperElement.classList.add("price");
      this.priceWrapperElement.classList.remove("price-original");
    }

    const isSubscriptionDiscount = !!state.frequency && !!discount;

    const hasSubscriptionElements =
      !!this.subscriptionSavingLabelElement && !!this.subscriptionSavingLabelAmountElement;

    if (isSubscriptionDiscount && hasSubscriptionElements) {
      Hider.show(this.subscriptionSavingLabelElement!);
      this.subscriptionSavingLabelAmountElement!.innerHTML = discount!.discountSaving;
    } else if (hasSubscriptionElements) {
      Hider.hide(this.subscriptionSavingLabelElement!);
    }

    if (this.subscriptionPerItemNote) {
      Hider.match(this.subscriptionPerItemNote, !!state.frequency);
    }
  }

  public static Factory: DomFactory<PriceViewer> = (e) => new PriceViewer(e);
}
